import React from 'react';
import PageContainer from '../components/Layout/PageContainer';
import { useLanguage } from '../i18n/LanguageContext';
import '../styles/lectureUpload.css';

const LecturePricingPage = () => {
  const { t } = useLanguage();

  return (
    <PageContainer>
      <div className="card upload-hero">
        <h1 className="card-title">{t('pricingTitle')}</h1>
        <p className="status-helper-text">{t('pricingSubtitle')}</p>
      </div>

      <div className="card">
        <p className="status-helper-text">{t('pricingComingSoon')}</p>
        <div className="metadata-grid">
          <div className="callout">
            <h3>{t('pricingPlanFree')}</h3>
            <p className="status-helper-text">Placeholder</p>
          </div>
          <div className="callout">
            <h3>{t('pricingPlanStudent')}</h3>
            <p className="status-helper-text">Placeholder</p>
          </div>
          <div className="callout">
            <h3>{t('pricingPlanPro')}</h3>
            <p className="status-helper-text">Placeholder</p>
          </div>
        </div>
      </div>
    </PageContainer>
  );
};

export default LecturePricingPage;
